(function () {
	'use strict';

	angular
		.module('wizard-english-test.constants')
		.constant('PATHS', {
			PHYSICAL: '/app/src/angular'
		})
		.constant('ROUTES', {
			APP: 'https://localhost:3000',
			APP_DEV: 'https://placement-dev.wizard.com.br',
			API: 'https://wizard-placement-test.mmserver.com.br/api',
		})
		.constant('DATA_EVENTS', {})
		.constant('APP', {
			IDENTIFIER: 'WizardEnglishTest',
			LEAD_LOCAL_DATA: 'LeadLocalData',
			IS_DEV: 'isDevTrue'
		})
}());